import { DEMAND, DEMAND_TYPE } from "@demandproai/shared";
import Dialog from "../../../../components/ui-control/Dialog";
import XButton from "../../../../components/common/XButton";
import { useVersionHistory } from "../../../../hooks/useVersionHistory";
import VersionList from "./VersionList";
import LifecareClientList from "./LifecareClientList";
import {
  vhmHeaderClasses,
  vhmHeaderTitleClasses,
  vhmBodyClasses,
  vhmColumnClasses,
  vhmColumnBorderLeftClasses,
  vhmColumnLabelClasses,
  vhmSeparatorClasses,
  vhmFileItemClasses,
  vhmFileItemActiveClasses,
  vhmPlaceholderClasses,
  vhmChevronClasses,
} from "./versionHistoryClasses";

const buildFileItemClassName = (isActive) =>
  `${vhmFileItemClasses}${isActive ? ` ${vhmFileItemActiveClasses}` : ""}`;

const VersionHistoryModal = ({
  isOpen,
  onClose,
  caseData,
  onDownloadComplete,
}) => {
  const {
    isLoading,
    lifecareClients,
    demands,
    CASE_FILES_KEY,
    MEDICAL_CHRONOLOGY_KEY,
    SILENT_WITNESS_KEY,
    selectedFileKey,
    selectedLifecareClientId,
    setSelectedLifecareClientId,
    handleSelectFile,
    handleDownload,
    isLifecareSelected,
    col2Versions,
    col3Versions,
    formatVersionLabel,
  } = useVersionHistory({ caseData, isOpen, onClose, onDownloadComplete });

  return (
    <Dialog
      isModalOpen={isOpen}
      onToggleDialog={(open) => {
        if (!open) onClose();
      }}
      mode="fit"
      shouldNotShowButtons
    >
      <div className={vhmHeaderClasses}>
        <span className={vhmHeaderTitleClasses}>Version History</span>
        <XButton variant="close" onClick={onClose} aria-label="Close">
          <i className="fa fa-times text-xl!" aria-hidden="true" />
        </XButton>
      </div>
      <div className={vhmBodyClasses}>
        <div className={vhmColumnClasses}>
          <div className={vhmColumnLabelClasses}>Files</div>
          {[
            { key: MEDICAL_CHRONOLOGY_KEY, label: "Medical Chronology" },
            { key: CASE_FILES_KEY, label: "Case Files" },
            { key: SILENT_WITNESS_KEY, label: "Silent Witness" },
          ].map(({ key, label }) => (
            <div
              key={key}
              className={buildFileItemClassName(selectedFileKey === key)}
              onClick={() => handleSelectFile(key)}
            >
              {label}
            </div>
          ))}
          {demands.length > 0 && (
            <>
              <div className={vhmSeparatorClasses}>Demands</div>
              {demands.map((v) => {
                const option = DEMAND_TYPE?.[v];
                const isLifecare = v === DEMAND.Lifecare_Plan;
                return (
                  <div
                    key={v}
                    className={buildFileItemClassName(selectedFileKey === v)}
                    onClick={() => handleSelectFile(v)}
                  >
                    {option?.text}
                    {isLifecare && (
                      <i
                        className={`fa fa-chevron-right ${vhmChevronClasses}`}
                        aria-hidden="true"
                      />
                    )}
                  </div>
                );
              })}
            </>
          )}
        </div>

        {selectedFileKey && (
          <div className={`${vhmColumnClasses} ${vhmColumnBorderLeftClasses}`}>
            <div className={vhmColumnLabelClasses}>
              {isLifecareSelected ? "Clients" : "Versions"}
            </div>
            {isLifecareSelected
              ? <LifecareClientList
                clients={lifecareClients}
                selectedClientId={selectedLifecareClientId}
                onSelect={setSelectedLifecareClientId}
              />
              : <VersionList
                versions={col2Versions}
                fileKey={selectedFileKey}
                onDownload={handleDownload}
                formatVersionLabel={formatVersionLabel}
                isLoading={isLoading}
              />}
          </div>
        )}

        {isLifecareSelected && selectedLifecareClientId && (
          <div className={`${vhmColumnClasses} ${vhmColumnBorderLeftClasses}`}>
            <div className={vhmColumnLabelClasses}>Versions</div>
            <VersionList
              versions={col3Versions}
              fileKey={DEMAND.Lifecare_Plan}
              lifecareClientId={selectedLifecareClientId}
              onDownload={handleDownload}
              formatVersionLabel={formatVersionLabel}
              isLoading={isLoading}
            />
          </div>
        )}

        {!selectedFileKey && (
          <div className={`${vhmColumnClasses} ${vhmColumnBorderLeftClasses} ${vhmPlaceholderClasses}`}>
            Select a file to see its versions
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default VersionHistoryModal;
